import { useLingui } from '@lingui/react/macro';

import {
  AREA_OF_CONCERN,
  RADIOGRAPHIC_BONELOSS,
  RESTORATIVE_ADJACENT_LUCENCY,
} from '../../../../../constants';
import type { FindingType } from '../../constants';
import { useFindingSidebarTranslations } from '../../constants';

export const useGetPathologyNameToDisplay = () => {
  const { typeToHeaderMap } = useFindingSidebarTranslations();
  const { t } = useLingui();
  const getPathologyNameToDisplay = (
    findingType: FindingType,
    rblInput: {
      text: string | undefined;
      measurement?: string | 'Unable to calculate bone level from X-ray';
    },
  ) => {
    if (findingType === RADIOGRAPHIC_BONELOSS) {
      return rblInput.measurement
        ? `${rblInput.text}: ${rblInput.measurement}`
        : t`Could not be calculated due to missing points`;
    }
    if (
      findingType === AREA_OF_CONCERN ||
      findingType === RESTORATIVE_ADJACENT_LUCENCY
    ) {
      return t`Finding`;
    }
    return typeToHeaderMap[findingType];
  };
  return getPathologyNameToDisplay;
};
